var render = function (_h,_vm) {var _c=_vm._c;return _c('button',_vm._g(_vm._b({class:[ _vm.$style[_vm.props.type || 'default'], _vm.data.class, _vm.data.staticClass ]},'button',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }